<nz-layout class="research-content-section">
  <nz-content>
    <!-- Document section -->
    <div class="document-viewer">
      <app-research-viewer
        [researchDocId]="researchDocId"
        [docInfo]="docInfo"
        [ticker]="ticker"
        (downloadDoc)="downloadDocument($event)"
      >
      </app-research-viewer>
    </div>
  </nz-content>
  <nz-sider
    [hidden]="!showRightSidebar"
    ngClass="rightSiderResearch"
    nzTheme="light"
    nzCollapsible
    [(nzCollapsed)]="isRightsideBarCollapsed"
    [nzCollapsedWidth]="0"
    (nzCollapsedChange)="collapseChanged()"
    [nzZeroTrigger]="rightSiderArrowTemplate"
  >
    <!-- Right panel section -->
    <nz-skeleton
      [nzLoading]="loading"
      [nzTitle]="true"
      [nzActive]="true"
      [nzParagraph]="{ rows: 19 }"
    >
      <div id="researchRightSection">
        <!-- Broker details section -->
        <div id="broker-details" class="broker-section" *ngIf="publishedDate">
          <span class="broker-name-header">{{ brokerName }}</span>
          <div class="published-date-div">
            Published :
            <span style="width: 44px;">{{
              publishedDate | date: "dd MMM
              yy"
            }}</span>
          </div>
          <div id="download-print">
            <span
              id="downloadDocument"
              *ngIf="
                documentType != 'html' &&
                documentType != 'linkback' &&
                documentType != ''
              "
              (click)="downloadDocument('SP')"
              class="download-research"
            >
              <va-icon size="small" name="download"></va-icon>
            </span>
            <span
              id="printDocument"
              (click)="printDocument()"
              *ngIf="documentType == 'pdf' && !isPrinting"
              class="print-research"
            >
              <va-icon size="small" name="print"></va-icon>
            </span>
            <span
              *ngIf="documentType == 'pdf' && isPrinting"
              class="print-research"
            >
              <va-icon [name]="faSpinner" isFontAwesome="true" [spin]="true"></va-icon>
            </span>
          </div>
        </div>
        <!-- chart dropdowns section -->
        <div id="chart-params" *ngIf="companies.length">
          <app-ticker-selector
            [(tickerSelectorObj)]="tickerSelectorObj"
            [(companies)]="companies"
            (callback)="onLineitemChange($event)"
          >
          </app-ticker-selector>
        </div>
        <!-- Chart section -->
        <div id="chart-research-section" *ngIf="companies.length">
          <app-research-chart-carousel
            [(tickerDetails)]="selectedTicker"
            [(lineItem)]="lineItem"
          ></app-research-chart-carousel>
        </div>
        <!-- analyst section -->
        <div
          id="analystDetails"
          class="analyst-section"
          *ngIf="analystList.length"
        >
          <div class="submenu_part_subheader">
            <span>Analyst ({{ analystList.length }})</span>
          </div>
          <div class="submenu_content" id="analystDetailsContent">
            <div *ngFor="let row of analystList">
              <div
                nz-row
                (mouseenter)="row.showIcon = true"
                (mouseleave)="row.showIcon = false"
                class="row-border-bottom submenu_row"
                [ngClass]="{ selected: row.showIcon }"
              >
                <div nz-col nzSpan="21" class="analyst-name">
                  {{ row.displayName }}
                </div>
                <div
                  nz-col
                  nzSpan="3"
                  style="text-align: right;"
                  [hidden]="!row.showIcon"
                >
                  <a
                    href="mailto:{{ row.email }}"
                    [hidden]="!row.email"
                    title="Email:{{ row.email }}"
                  >
                    <va-icon class="analyst-mail" [name]="faEnvelope" isFontAwesome="true"></va-icon>
                  </a>
                  <span
                    class="analyst-phone"
                    title="Phone : {{ row.phone }}"
                    [hidden]="!row.phone"
                  >
                    <va-icon [name]="faPhoneAlt" isFontAwesome="true"></va-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-more-analyst-research
          *ngIf="analystList.length"
          [analystList]="analystList"
          [researchDocId]="researchDocId"
          [documentType]="documentType"
        ></app-more-analyst-research>
        <!-- models -->
        <div id="models" class="models-section" *ngIf="modelsData.length">
          <div class="submenu_part_subheader">
            <span>Models</span>
          </div>
          <div
            class="submenu_content"
            id="modelsContent"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="20"
            (scrolled)="onScroll()"
            [scrollWindow]="false"
          >
            <div
              nz-row
              *ngFor="let row of modelsDataFilteredSorted"
              class="row-border-bottom"
              (mouseenter)="row.showIcon = true"
              (mouseleave)="row.showIcon = false"
            >
              <div nz-col nzSpan="4" class="date">
                {{ row.date | date: "dd-MMM " }}
              </div>
              <ng-container
                class="disabled-download"
                *ngIf="
                  row.isModelEntitled &&
                  row.fileSize &&
                  !row.isDownloadApplicable
                "
               
              >
                <a nz-col nzOffset="1" nzSpan="18"  title="A downloadable model is not currently available">
                  <span class="model-link">{{ row.company }}</span>
                </a>
                <a nz-col nzSpan="1" [hidden]="!row.showIcon">
                  <va-icon class="download-icon" size="small" name="download"></va-icon>
                </a>
              </ng-container>

              <ng-container
                class="disabled-download"
                *ngIf="!row.isModelEntitled && row.fileSize"
               
              >
                <a nz-col nzOffset="1" nzSpan="18"  title="Not entitled">
                  <span class="model-link">{{ row.company }}</span>
                </a>
                <a nz-col nzSpan="1" [hidden]="!row.showIcon">
                  <va-icon class="download-icon" size="small" name="download"></va-icon>
                </a>
              </ng-container>

              <ng-container
                (click)="downloadModel(row.id)"
                *ngIf="
                  row.isModelEntitled &&
                  row.fileSize &&
                  row.isDownloadApplicable
                "
              
              >
                <a nz-col nzOffset="1" nzSpan="18"   title="Download {{ row.fileName }}">
                  <span class="model-link">{{ row.company }}</span>
                </a>
                <a nz-col nzSpan="1" [hidden]="!row.showIcon">
                  <va-icon class="download-icon" size="small" name="download"></va-icon>
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </nz-skeleton>
  </nz-sider>
  <ng-template #rightSiderArrowTemplate>
    <va-icon
      *ngIf="isRightsideBarCollapsed"
      name="arrow-circle-left"
      class="fa fa-md sider-icon"
    ></va-icon>
    <va-icon
      *ngIf="!isRightsideBarCollapsed"
      name="arrow-circle-right"
      class="fa fa-md sider-icon"
    ></va-icon>
  </ng-template>
</nz-layout>
